module.exports = __webpack_public_path__ + "img/user-1.d8252a08.png";